import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import {
  postMember1,
  postMember7,
  postMember8,
  postMobile2,
  postMobile3,
} from "../../common/redux/MasterLayoutCRUD";
import { homeSlice } from "./HomeSlice";

const { actions } = homeSlice;

export const updateHomePageUI = () => (dispatch) => {
  dispatch(actions.updateHomePageUI());
};

export const resetIBCWidgetUrl = () => (dispatch) => {
  dispatch(actions.ibcWidgetLinkFetched({ data: null }));
};

export const getIBCWidgetUrl = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postMember7(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.ibcWidgetLinkFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: getIBCWidgetUrl");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const createIBC = (queryParams) => (dispatch) => {
  dispatch(actions.updateHomePageUI());
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postMember7(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.ibcWidgetLinkFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: createIBC");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const topupIBC = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postMember8(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.ibcBalanceFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: topupIBC");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const getHomePageUI = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMobile3(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.homePageUIFetched({ data: response.data }));

          return response;
        }
      } else {
        throw new Error("Error api: fetchHomePageUI");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const getHomePageHistory = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMobile2(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.homePageHistoryFetched({ data: response.data }));

          return response;
        }
      } else {
        throw new Error("Error api: getHomePageHistory");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const getHomePageMemberData = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMember1(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.homePageMemberDataFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchHomePageMemberData");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};
